export default __webpack_public_path__ + "static/media/component.09a4de8d.svg";